import {
    ConfirmSignUp,
    ForgotPassword,
    ResetPassword,
    SetupPassword,
    SignIn,
} from 'containers/auth';
import { DistributorTunnel, InvestorTunnel, TunnelIframe } from 'containers/tunnel';
import { texts } from 'utils/languages/fr';

export default [
    {
        key: 'sign-in',
        path: '/sign-in',
        exact: true,
        label: texts.SIGN_IN,
        component: SignIn,
    },
    {
        key: 'confirm-email',
        path: '/confirm-email',
        exact: false,
        label: texts.CONFIRM_EMAIL,
        component: ConfirmSignUp,
    },
    {
        key: 'forgot-password',
        path: '/forgot-password',
        exact: true,
        label: texts.FORGOT_PASSWORD,
        component: ForgotPassword,
    },
    {
        key: 'reset-password',
        path: '/reset-password',
        exact: false,
        label: texts.RESET_PASSWORD,
        component: ResetPassword,
    },
    {
        key: 'setup-password',
        path: '/setup-password',
        exact: false,
        label: texts.SETUP_PASSWORD,
        component: SetupPassword,
    },
    {
        key: 'tunnel-page',
        path: '/sign-up/*',
        exact: false,
        label: texts.GENERIC_STEP_PAGE,
        component: InvestorTunnel,
    },
    {
        key: 'tunnel-iframe-error',
        path: '/sign-up-error',
        role: [],
        exact: true,
        label: texts.GENERIC_STEP_PAGE,
        component: TunnelIframe,
    },
    {
        key: 'tunnel-iframe-success',
        path: '/sign-up-success',
        role: [],
        exact: true,
        label: texts.GENERIC_STEP_PAGE,
        component: TunnelIframe,
    },
    {
        key: 'onboarding',
        path: '/onboarding/*',
        role: [],
        exact: true,
        component: DistributorTunnel,
    },
];
